/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GrundbuchamtId } from './grundbuchamtId';
import { PolitischeGemeindeId } from './politischeGemeindeId';
import { GbGemeindeId } from './gbGemeindeId';
import { MultilanguageText } from './multilanguageText';


export interface GbGemeindeListEntry { 
    id?: GbGemeindeId;
    politischeGemeindeId?: PolitischeGemeindeId;
    bfsNummer?: number;
    kreisNummer?: string;
    subKreis?: string;
    gemeindeArt?: GbGemeindeListEntry.GemeindeArtEnum;
    los?: string;
    auslGemNr?: string;
    name?: MultilanguageText;
    namede?: string;
    namefr?: string;
    nameit?: string;
    nameen?: string;
    kuerzel?: string;
    grundbuchFuehrung?: GbGemeindeListEntry.GrundbuchFuehrungEnum;
    amtsSprache?: GbGemeindeListEntry.AmtsSpracheEnum;
    gueltig?: boolean;
    grundbuchamtId?: GrundbuchamtId;
}
export namespace GbGemeindeListEntry {
    export type GemeindeArtEnum = 'GB_GEMEINDEKREIS' | 'GB_GEMEINDE_OHNEKREIS' | 'SEYBUCH' | 'SEYBUCH_GEMEINDE_OHNEKREIS' | 'AUSLAENDISCHE_GEMEINDE';
    export const GemeindeArtEnum = {
        GBGEMEINDEKREIS: 'GB_GEMEINDEKREIS' as GemeindeArtEnum,
        GBGEMEINDEOHNEKREIS: 'GB_GEMEINDE_OHNEKREIS' as GemeindeArtEnum,
        SEYBUCH: 'SEYBUCH' as GemeindeArtEnum,
        SEYBUCHGEMEINDEOHNEKREIS: 'SEYBUCH_GEMEINDE_OHNEKREIS' as GemeindeArtEnum,
        AUSLAENDISCHEGEMEINDE: 'AUSLAENDISCHE_GEMEINDE' as GemeindeArtEnum
    };
    export type GrundbuchFuehrungEnum = 'EIDGENOESSISCH' | 'KANTONAL' | 'EINFUEHRUNG';
    export const GrundbuchFuehrungEnum = {
        EIDGENOESSISCH: 'EIDGENOESSISCH' as GrundbuchFuehrungEnum,
        KANTONAL: 'KANTONAL' as GrundbuchFuehrungEnum,
        EINFUEHRUNG: 'EINFUEHRUNG' as GrundbuchFuehrungEnum
    };
    export type AmtsSpracheEnum = 'DEUTSCH' | 'FRANZOESISCH' | 'ITALIENISCH' | 'ENGLISCH';
    export const AmtsSpracheEnum = {
        DEUTSCH: 'DEUTSCH' as AmtsSpracheEnum,
        FRANZOESISCH: 'FRANZOESISCH' as AmtsSpracheEnum,
        ITALIENISCH: 'ITALIENISCH' as AmtsSpracheEnum,
        ENGLISCH: 'ENGLISCH' as AmtsSpracheEnum
    };
}


